<!--  -->
<template>
  <div>
    <myhead />
    <div class="left">
      <img src="../assets/left.gif" />
      <img class="img-1" src="../assets/left-1.png" />
    </div>
    <div class="right">
      <img src="../assets/right.gif" />
      <img src="../assets/right-1.png"/>
    </div>
    <div class="bottom">
      <img src="../assets/bottom.gif" />
      <img src="../assets/bottom.png" >
    </div>
    <overview v-if="show == 0" />
    <testing v-if="show ==1" />
    <navigation @viewshow="viewshow" />
    <security v-if="show ==2" />
    <equipment v-if="show ==3" />
    <four v-if="show ==4" />
  </div>
</template>

<script>
import myhead from "../components/myhead.vue";
import overview from "../components/overview.vue";
import testing from "../components/testing.vue";
import navigation from "../components/navigation.vue";
import security from "../components/security.vue";
import equipment from "../components/equipment/equipment.vue";
import four from "../components/bottom_four.vue";
export default {
  data() {
    return {
      show: 0,
      gtcli: 0,
      aqjk: 0,
      afjk: 0
    };
  },

  components: {
    myhead,
    overview,
    navigation,
    testing,
    security,
    equipment,
    four
  },

  computed: {},

  methods: {
    viewshow(val) {
      switch (val) {
        case 0:
          this.show = 0;
          document.getElementById("iframe").contentWindow.MMSDT.coverage();
          document.getElementById("iframe").contentWindow.cameraTargets(0);
          document.getElementById("iframe").contentWindow.MMAPI.objStyle(1);
          document.getElementById("iframe").contentWindow.MMAPI.endDrawRom();
          document.getElementById("iframe").contentWindow.MMAPI.upLight(0);
          document.getElementById("iframe").contentWindow.xfbj111();
          break;

        case 1:
          this.show = 1;
          document.getElementById("iframe").contentWindow.MMSDT.coverage();
          document.getElementById("iframe").contentWindow.cameraTargets(0);
          document.getElementById("iframe").contentWindow.MMAPI.objStyle(1);
          document.getElementById("iframe").contentWindow.MMAPI.endDrawRom();
          document.getElementById("iframe").contentWindow.MMAPI.upLight(0);
          document.getElementById("iframe").contentWindow.xfbj111();
          break;

        case 2:
          this.show = 3;
          document.getElementById("iframe").contentWindow.MMAPI.objStyle(1);
          document.getElementById("iframe").contentWindow.MMAPI.endDrawRom();
          document.getElementById("iframe").contentWindow.MMAPI.upLight(0);
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["all"], "all");
          document.getElementById("iframe").contentWindow.xfbj111();
          break;
        case 3:
          document.getElementById("iframe").contentWindow.MMSDT.coverage();
          document.getElementById("iframe").contentWindow.MMAPI.objStyle(0);
          document.getElementById("iframe").contentWindow.MMAPI.endDrawRom();
          document.getElementById("iframe").contentWindow.MMAPI.upLight(0);
          document.getElementById("iframe").contentWindow.xfbj111();
          this.show = 4;
          break;
        case 4:
          document.getElementById("iframe").contentWindow.MMSDT.coverage();
          document.getElementById("iframe").contentWindow.MMAPI.objStyle(1);
          document.getElementById("iframe").contentWindow.MMAPI.endDraw();
          document.getElementById("iframe").contentWindow.MMAPI.upLight(1);
          document.getElementById("iframe").contentWindow.xfbj111();
          this.show = 2;
          break;
        case 5:
          document.getElementById("iframe").contentWindow.MMSDT.coverage();
          document.getElementById("iframe").contentWindow.cameraTargets(0);
          document.getElementById("iframe").contentWindow.MMAPI.objStyle(1);
          document.getElementById("iframe").contentWindow.MMAPI.endDrawRom();
          document.getElementById("iframe").contentWindow.MMAPI.upLight(0);
          document.getElementById("iframe").contentWindow.xfbj();
           this.show = 5;
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.left {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 290px;
  background: url("../assets/left-bj.png") no-repeat;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  img {
    position: absolute;
    height: 100%;
  }
  
}
.img-1{
    position: absolute;
    height: 100%;
    overflow: hidden;
  }
.right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 250px;
  background: url("../assets/right-bj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  img {
    position: absolute;
    right: 2px;
    height: 100%;
  }
}
.bottom {
  position: absolute;
  bottom: 0px;
  height: 200px;
  width: 100%;
  // margin-left: 2.5%;
  background: url("../assets/batton-bj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  img {
    position: absolute;
    width: 94.7%;
    bottom: 2px;
    right: 50px;
  }
}
</style>